import { render, staticRenderFns } from "./Play_Apply4.vue?vue&type=template&id=3b2c6bcc&scoped=true"
import script from "./Play_Apply4.vue?vue&type=script&lang=js"
export * from "./Play_Apply4.vue?vue&type=script&lang=js"
import style0 from "./Play_Apply4.vue?vue&type=style&index=0&id=3b2c6bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2c6bcc",
  null
  
)

export default component.exports